export enum ColumnType {
    unknown = 0,
    ignore = 5,
    userUnselectedIdentity = 10,
    userUnselected = 15,
    dimension = 20,
    dimensionUnselectedComplexity = 21,
    control = 25,
    formulaComponent = 35,
    outcome = 40,
}